// extracted by mini-css-extract-plugin
export default {"container":"Appointments_container__mdfcb","buttonContainer":"Appointments_buttonContainer__6kc7n"};